import { CopyError } from '../copy/text.js';
import { viewerStrings } from '../copy/strings.js';
import { baseQuery } from '@cdr-clarity/query-service';
import type { RelationshipQueryDefinition } from '@cdr-clarity/contracts';
import type { UnifiedRecordsState } from './unified-records-state.js';

/** Export scope is explicit; selecting sources does not depend on an unrelated active filter. */
export function relationshipExportState(store: UnifiedRecordsState, selected: boolean) {
  const snapshot = store.getSnapshot();
  const { preference } = store.fields.getSnapshot();
  const columns = [
    ...new Set([
      ...preference.order.flatMap((id) =>
        snapshot.visibleFields
          .filter((field) => field.id === id || field.sourceField === id)
          .map((field) => field.id),
      ),
      ...snapshot.visibleFields.map((field) => field.id),
    ]),
  ].map((id) => snapshot.visibleFields.find((field) => field.id === id)!);
  if (!columns.length)
    throw new CopyError(viewerStrings.webStateRelationshipExportState.showAtLeastOneFieldToExport);
  if (!selected) return { query: store.definition(), columns };
  if (!snapshot.selected.size)
    throw new CopyError(viewerStrings.webStateRelationshipExportState.selectRecordsToExport);
  const order = preference.sort.map((sort) => {
    const field =
      columns.find((field) => field.id === sort.key) ??
      columns.find((field) => field.sourceField === sort.key && field.binding === 'primary') ??
      columns.find((field) => field.sourceField === sort.key);
    if (!field)
      throw new CopyError(
        viewerStrings.webStateRelationshipExportState.theExportSortUsesAHiddenField,
      );
    return { ...sort, key: field.id };
  });
  const query: RelationshipQueryDefinition = {
    ...baseQuery({
      ...snapshot.scope,
      collection: 'cdr',
      recordIds: [...snapshot.selected],
      excludedRecordIds: [],
    }),
    kind: 'relationship-projection',
    relationship: { type: 'media', targetCollection: 'cmr', includeUnmatched: true },
    measures: [],
    order,
    visibleFields: store.fields.getSnapshot().visible.map((field) => field.id),
  };
  return { query, columns };
}
